import axios from "../utils/axios";

export default function fetchPremiumHistoryList(adminId, params) {
  return axios.get("/admin/" + adminId + "/job-premium-list", { params });
}
